import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>
      <footer className="footer-area" style={{ marginTop: "-80px" }}>
        <div className="footer-shape">
          <img src="assets/school/priyadarshani.png" alt />
        </div>
        <div className="footer-widget">
          <div className="container">
            <div className="row footer-widget-wrapper pt-100 pb-70">
              <div className="col-md-6 col-lg-4">
                <div className="footer-widget-box about-us">
                  <Link to="/" className="footer-logo">
                    <img src="assets/school/priyadarshani.png" alt style={{ height: "150px", width: "150px" }} />
                  </Link>
                  {/* <p className="mb-3">
                      We are many variations of passages available but the majority have suffered alteration
                      in some form by injected humour words believable.
                    </p> */}
                  <ul className="footer-contact">
                    <li><a href="tel:+91 7987105491"><i className="far fa-phone" />+91 7987105491</a></li>
                    <li> <a href='https://share.google/yuu4U0twsch2AWV4Q' target="_blank"> <i className="far fa-map-marker-alt" />Swami Chowk, Mukhtiyarganj Satna (M.P.)</a></li>
                    <li><Link to="mailto:pchs.satna@gmail.com"><i className="far fa-envelope" />pchs.satna@gmail.com</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-2">
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Quick Links</h4>
                  <ul className="footer-list">
                    <li><Link to="/"><i className="fas fa-caret-right" /> Home</Link></li>
                    <li><Link to="/about-us"><i className="fas fa-caret-right" /> About Us</Link></li>
                    <li><Link to="/gallery"><i className="fas fa-caret-right" /> Our Gallery</Link></li>
                    <li><Link to="/facility"><i className="fas fa-caret-right" /> Our Facility</Link></li>
                    <li><Link to="/activities"><i className="fas fa-caret-right" />  Our Activities</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Our Campus</h4>
                  <ul className="footer-list">
                    <li><Link to="/blog"><i className="fas fa-caret-right" /> Our Blog</Link></li>
                    {/* <li><Link to="/admission"><i className="fas fa-caret-right" /> Admission</Link></li> */}
                    <li><Link to="/top-result"><i className="fas fa-caret-right" /> Top Result</Link></li>
                    <li><Link to="/contact-us"><i className="fas fa-caret-right" /> Contact Us</Link></li>
                    <li><Link to="/director-message"><i className="fas fa-caret-right" /> Director Message</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Newsletter</h4>
                  <div className="footer-newsletter">
                    <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=400&height=200&hl=en&q=priyadarshani convent high school Higher secondary school in Satna, Madhya Pradesh&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://nicemail.cc/">temp mail</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:200px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:200px;}.gmap_iframe {height:200px!important;}" }} /></div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <div className="copyright-wrapper">
              <div className="row">
                <div className="col-md-6 align-self-center">
                  <p className="copyright-text">
                    <span id="date"></span> <a href="tel:+91 8982471422"> © 2026 Priyadarshani Convent High School | Designed by Web solution </a>
                  </p>
                </div>
                <div className="col-md-6 align-self-center">
                  <ul className="footer-social">
                    <li><Link to="https://www.instagram.com/pchschool?igsh=MTVpdHltbDl3N2lxbw%3D%3D" target="_blank" ><i className="fab fa-instagram" /></Link></li>
                    <li><Link to="https://www.facebook.com/Pchs.satna/" target="_blank" ><i className="fab fa-facebook-f" /></Link></li>
                    <li><Link to="https://wa.me/917987105491" target="_blank" ><i className="fab fa-whatsapp" /></Link></li>
                    <li><Link to="https://www.youtube.com/@PCHSSATNA/videos" target="_blank" ><i className="fab fa-youtube" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <Link to="/" id="scroll-top"><i className="far fa-arrow-up-from-arc" /></Link>
      {/* <PopUp /> */}
      <WhatsappIcon />
    </>
  )
}

export default Footer